import React from 'react';

// Services & Helpers
import API from 'API';

//-----------------------------------------------------------------

class SetupDebug extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isRebuildingSearchIndex: false
        };
    }

    componentDidMount() {
        this.props.fns.setTitle('Debug setup');
    }

    async rebuildSearchIndex() {
        const confirm = window.confirm('This may take a few minutes and searching will not work while this is running. Continue?');
        if (!confirm) {
            return;
        }

        this.setState({ isRebuildingSearchIndex: true });
        try {
            await API.call('debug/rebuild-search-index');
            alert('Search index rebuilt.');
        } finally {
            this.setState({ isRebuildingSearchIndex: false });
        }
    }

    //---------------------------------------------------------------------------------------------------------------

    render() {
        const { isRebuildingSearchIndex } = this.state;

        return (<>

            <section className="control-panel sticky">

                <h1>Debug</h1>

            </section>

            <section>

                <button
                    type="button"
                    className="btn btn-primary"
                    disabled={isRebuildingSearchIndex}
                    onClick={() => this.rebuildSearchIndex()}
                >
                    {isRebuildingSearchIndex ? 'Rebuilding...' : 'Rebuild search index'}
                </button>

            </section>

        </>);
    }

}

export default SetupDebug;
